import React from "react";
import "../studyabroad/studyAbroad.css";
import InquiryForm from "../InquiryForm";

const StudyInGermany = () => {
  return (
    <div className="study-abroad-container">

      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="hero-text">
          <h1>Study Abroad in Germany</h1>
          <p>
            Germany is one of the world’s leading destinations for higher education.
            With nearly 450 state-accredited universities and over 17,500 degree programs,
            Germany offers globally recognized qualifications and outstanding academic excellence.
            Many programs, especially at the master’s level, are offered in English.
          </p>
        </div>

        <div className="hero-image">
          <img
            src="https://images.unsplash.com/photo-1528728329032-2972f65dfb3f"
            alt="Study in Germany"
          />
        </div>
      </section>

      {/* INFO SECTION */}
      <section className="info-section">

        <div className="info-card">
          <h2>Top-Class Education</h2>
          <p>
            German university degrees are highly respected worldwide.
            Universities offer bachelor’s, master’s, doctoral and state examination
            programs across every academic field.
          </p>
        </div>

        <div className="info-card">
          <h2>Affordable Education</h2>
          <p>
            Most public universities in Germany do not charge tuition fees for
            bachelor’s programs. Even when fees apply, they are significantly lower
            compared to other countries.
          </p>
        </div>

        <div className="info-card">
          <h2>Cost of Living</h2>
          <p>
            Living expenses in Germany are reasonable compared to other European
            countries. Students also receive discounts at museums, theatres,
            cinemas, and public institutions with their student ID.
          </p>
        </div>

        <div className="info-card">
          <h2>Scholarship Opportunities</h2>
          <p>
            The German Academic Exchange Service (DAAD) offers numerous
            scholarship programs for international students. Outstanding
            students have excellent chances of securing financial support.
          </p>
        </div>

        <div className="info-card">
          <h2>Practice-Oriented Learning</h2>
          <p>
            Universities of Applied Sciences provide career-focused programs.
            Many courses combine theory with practical experience, helping
            students smoothly transition into the job market.
          </p>
        </div>

        <div className="info-card">
          <h2>Safe & Diverse Country</h2>
          <p>
            Germany is known for its safety, political stability, and economic
            strength. Students enjoy a multicultural environment and can explore
            rich history, landscapes, and vibrant city life.
          </p>
        </div>

      </section>

      {/* WHY STUDY SECTION */}
      <section className="why-section">
        <h2>Why Study in Germany?</h2>
        <ul>
          <li>Globally recognized degrees</li>
          <li>Tuition-free or low-cost education</li>
          <li>Excellent research and innovation facilities</li>
          <li>Strong industry connections</li>
          <li>Scholarship opportunities (DAAD & others)</li>
          <li>Safe and economically stable country</li>
          <li>Multicultural international student community</li>
        </ul>
      </section>

      {/* INTAKE SECTION */}
      <section className="intake-section">
        <h2>Intake</h2>
        <p>
          Germany mainly has two intakes:
          <br /><br />
          <strong>Winter Semester (October)</strong><br />
          Application deadline: <strong>15th July</strong>  
          Application period: June – 15th July
          <br /><br />
          <strong>Summer Semester (April)</strong><br />
          Application deadline: <strong>15th January</strong>  
          Application period: December – 15th January
        </p>
      </section>

      {/* INQUIRY FORM */}
      <InquiryForm title="Inquire About Study in Germany" />

    </div>
  );
};

export default StudyInGermany;
